const actions = {
  GET_ITEMS_SALES_REQUEST: "GET_ITEMS_SALES_REQUEST",
  GET_ITEMS_SALES_SUCCESS: "GET_ITEMS_SALES_SUCCESS",
  // SORT_ITEMS: 'SORT_ITEMS',
  getItemSales: (startDate, endDate, selectedRestaurant) => {
    return (dispatch) => {
      dispatch({
        type: actions.GET_ITEMS_SALES_REQUEST,
        startDate,
        endDate,
        selectedRestaurant,
      });
    };
  },
};
export default actions;
